import React, { useEffect, useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Spinner } from "react-bootstrap";
import Blue_Btn from "../../../../common_components/common_btn/Blue_Btn/Blue_Btn";

const Payment_Summary = ({
  data,
  app_setup,
  viewAllSummary,
  isCheckoutPage,
  show,
  refund,
}) => {
  return (
    <>
      <div className="payment_summary_div">
        {!viewAllSummary && (
          <h3 className="heading">
            <img src="/assets/images/icons/pdf.png" className="icon_img" />{" "}
            Order Summary
          </h3>
        )}

        <div className="summary">
          {/* Total no. of items */}
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>

            <div className="qty_div">
              <p>{data?.no_of_item || 1} Nos.</p>
            </div>
          </div>

          {/* Payment Mode */}
          {data?.payment_method && (
            <div className="row-divider">
              <div className="title_div">
                <p>Payment Mode</p>
              </div>

              <div className="qty_div">
                <p>{data?.payment_method} </p>
              </div>
            </div>
          )}

          {/* Taxable value/ Cart value Total */}
          <div className="row-divider">
            <div className="title_div">
              <p>Taxable value/ Cart value</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(data?.total_selling_price).toFixed(2)}</p>
            </div>
          </div>

          {/* CGST/SGST */}
          <div className="row-divider">
            <div className="title_div">
              {/* <p>{data?.Tax_Type?.name || "CGST/SGST"}</p> */}
              <p>{data?.Tax_Type?.name || "Tax"}</p>
            </div>

            <div className="qty_div">
              <p>
                ₹ {data?.total_tax ? Number(data.total_tax).toFixed(2) : "0.00"}
              </p>
            </div>
          </div>

          {/* {isCheckoutPage && (
            <div className="row-divider">
              <div className="title_div">
                <p>GST Number</p>
              </div>

              <div className="qty_div">
                <Blue_Btn
                  onClick={() => setModalShow(true)}
                  btn_name="GST Number"
                />
              </div>
            </div>
          )} */}

          {/* GST Number */}
          {!show && (
            <>
              {/* <div className="row-divider">
                <div className="title_div">
                  <p>Offer Discount</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {parseFloat(
                      data?.total_offer_discount || data?.offer_discount || 0,
                    ).toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="row-divider">
                <div className="title_div">
                  <p>Coupon Discount</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {data?.total_coupon_discount || data?.coupon_discount || 0}
                  </p>
                </div>
              </div> */}

              {/* <div className="row-divider">
                <div className="title_div">
                  <p>Convenience Fee</p>
                </div>

                <div className="qty_div">
                  <p>
                    ₹{" "}
                    {parseFloat(
                      data?.total_platformCharge || data?.platform_fee || 0,
                    ).toFixed(2)}
                  </p>
                </div>
              </div> */}

              <div className="row-divider">
                <div className="delivery_title_div">
                  <div className="title_div">

                  <p>
                    Delivery Charges{" "}
                    {/* <span className="inner_title">- Free Delivery</span> */}
                  </p>
                  </div>
                </div>

                <div className="qty_div">
                  <span
                    style={{
                      textDecoration: "line-through",
                      color: "#888",
                      marginRight: "6px",
                    }}
                  >
                    ₹ {app_setup?.delivery_price || 0}
                  </span>

                  <span
                    style={{
                      color: "red",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                  >
                    OFF
                  </span>
                </div>
              </div>
            </>
          )}

          {/* Total Save */}
          <div className="row-divider">
            <div className="title_div">
              <p>Total Save</p>
            </div>

            <div className="qty_div">
              <p>
                ₹{" "}
                {(
                  Number(data?.total_mrp ?? 0) +
                  Number(data.total_tax) -
                  Number(data?.total_selling_price ?? 0) +
                  Number(data.total_tax) +
                  Number(
                    data?.total_coupon_discount || data?.coupon_discount || 0,
                  ) +
                  Number(
                    data?.total_offer_discount || data?.offer_discount || 0,
                  )
                ).toFixed(2)}
              </p>
            </div>
          </div>

          <div className="total_div">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_qty_div">
                  <p>Rs. {Number(data?.total_amount || 0).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>

          {refund && (
            <div className="row-divider">
              <div className="title_div">
                <p>Refund Amount</p>
              </div>

              <div className="qty_div">
                <p>
                  ₹{" "}
                  {Number(data?.Product_Order?.no_of_item) ===
                    Number(data?.Product_Order?.cancel_on_of_item) ||
                  Number(data?.Product_Order?.no_of_item) ===
                    Number(data?.Product_Order?.return_on_of_item)
                    ? (
                        Number(data?.total_amount || 0) -
                        Number(data?.platform_fee || 0)
                      ).toFixed(2)
                    : (
                        Number(data?.total_amount || 0) -
                        (Number(data?.platform_fee || 0) +
                          Number(data?.delivery_charges || 0))
                      ).toFixed(2)}
                </p>
              </div>
            </div>
          )}

          {/* {!isCheckoutPage && (
            <>
              <div className="forgot_div">
                <p className="forgot_text">Forgot Something?</p>
                <div className="add_btn_div">
                  <Blue_Btn
                    btn_name="+ Add more items"
                    onClick={() => {
                      navigate("/shop");
                    }}
                  />
                </div>
              </div>

              <div className="checkout_btn">
                {canProceed ? (
                  <>
                    {" "}
                    <Blue_Btn
                      btn_name=" Proceed To Checkout"
                      onClick={() => {
                        isSignIn ? setShowModal(true) : setShowLoginModal(true);
                      }}
                    />
                    {canProceed && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {canProceed}
                      </div>
                    )}
                  </>
                ) : (
                  <Blue_Btn
                    btn_name="Proceed To Checkout"
                    onClick={() => {
                      isSignIn ? setShowModal(true) : setShowLoginModal(true);
                    }}
                  />
                )}
              </div>
            </>
          )} */}
        </div>
      </div>

      {/* {isCheckoutPage && (
        <div className="payment_summary_div coupon_main_div">
          <div className="coupon_div">
            <div className="special_div">
              <img
                src="/assets/images/checkout/green_discount.png"
                className="discount_img"
              />
              <p className="special_text">Something Special for you!</p>
            </div>
            <div className="coupons_div">
              <div className="left_side">
                <FontAwesomeIcon icon={faTags} className="tag_icon" />
                <span className="coupon_text">
                  {CouponData?.code || "Coupons"}
                </span>
              </div>
              {CouponData ? (
                <div className="btn_holder">
                  <button
                    className="black_btn"
                    onClick={() => {
                      setCouponData("");
                    }}
                  >
                    Remove
                  </button>
                </div>
              ) : (
                <div className="btn_holder">
                  <button
                    className="black_btn"
                    onClick={() => {
                      setShowOffCanvas(true);
                    }}
                  >
                    View
                  </button>
                </div>
              )}
            </div>
          </div>
          {Errors && (
            <p style={{ color: "red", marginTop: "8px", fontSize: "14px" }}>
              {Errors}
            </p>
          )}
          <div className="checkout_btn">
            <Green_Btn
              btn_name={
                loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Processing...
                  </>
                ) : (
                  checkout_btn
                )
              }
              onClick={!loading ? checkoutAction : undefined} // prevent click when loading
              disabled={loading} // also disable button
            />
          </div> 
        </div>
      )} */}

      {/* <Offcanvas
        className="right_bottom_offcanvas"
        placement="bottom"
        show={showOffCanvas}
        onHide={() => {
          setShowOffCanvas(false);
        }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
          </Offcanvas.Title>
          <div
            className="icon_holder"
            onClick={() => {
              setShowOffCanvas(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="coupon_cards_div">
            {coupons?.data?.length <= 0 && "Coupon Not available"}
            {coupons?.data?.map((val) => (
              <Coupon_Card val={val} data={data} handelSubmit={handelSubmit} />
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* <Offcanvas
        className="right_bottom_offcanvas confirm_delivery_address_offcanvas"
        placement="bottom"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Offcanvas.Body>
          <div className="Confirm_Addess_Modal">
            <div className="modal-content">
              <div className="modal-header">
                <div className="title_text">
                  <p>Confirm Delivery Address</p>
                </div>

                <div className="right_side">
                  <img
                    src="/assets/images/cart/close.png"
                    className="close_img"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  />
                </div>
              </div>

              <div className="modal-body">
                <div className="address_holder">
                  <p className="type_text">
                    {" "}
                    <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                    Shipping Address
                  </p>

                  {allAddress?.data?.length > 0 && (
                    <p className="address_text">
                      {allAddress?.data[0]?.building},
                      {allAddress?.data[0]?.floor},
                      {allAddress?.data[0]?.apartment},
                      {allAddress?.data[0]?.street},
                      {allAddress?.data[0]?.direction},
                      {allAddress?.data[0]?.Users_Address_Detail?.City?.name},
                      {allAddress?.data[0]?.Users_Address_Detail?.State?.name},
                      {allAddress?.data[0]?.Users_Address_Detail?.Country?.name}
                      ,
                      {allAddress?.data[0]?.Users_Address_Detail?.Pincode?.name}
                      ,
                    </p>
                  )}

                  <p className="type_text">
                    {" "}
                    <FontAwesomeIcon icon={faBuilding} className="inner_icon" />
                    Billing Address
                  </p>

                  {allBillingAddress?.data?.length > 0 && (
                    <p className="address_text">
                      {allBillingAddress?.data[0]?.building},
                      {allBillingAddress?.data[0]?.floor},
                      {allBillingAddress?.data[0]?.apartment},
                      {allBillingAddress?.data[0]?.street},
                      {allBillingAddress?.data[0]?.direction},
                      {
                        allBillingAddress?.data[0]?.Users_Address_Detail?.City
                          ?.name
                      }
                      ,
                      {
                        allBillingAddress?.data[0]?.Users_Address_Detail?.State
                          ?.name
                      }
                      ,
                      {
                        allBillingAddress?.data[0]?.Users_Address_Detail
                          ?.Country?.name
                      }
                      ,
                      {
                        allBillingAddress?.data[0]?.Users_Address_Detail
                          ?.Pincode?.name
                      }
                      ,
                    </p>
                  )}

                  {allAddress?.data?.length > 0 &&
                  allBillingAddress?.data?.length > 0 ? (
                    <div className="btns_holder">
                      <Gray_Btn
                        btn_name="Update Address"
                        onClick={() => {
                          navigate("/saved-address");
                        }}
                      />
                      <Green_Btn
                        btn_name="Proceed"
                        onClick={() => {
                          navigate("/checkout");
                        }}
                      />
                    </div>
                  ) : (
                    <div className="btns_holder">
                      <Gray_Btn
                        btn_name="Add Address"
                        onClick={() => {
                          navigate("/saved-address");
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showCouponModal}
        onHide={() => {
          setShowCouponModal(false);
        }}
        successText="Coupon applied successfully!"
      />

      <GST_modal
        GSTNumber={GSTNumber}
        setGSTNumber={setGSTNumber}
        show={modalShow}
        onHide={() => setModalShow(false)}
      /> */}
    </>
  );
};

export default Payment_Summary;
